module.exports = __webpack_public_path__ + "img/checkoff.cb081bd5.svg";